// extracted by mini-css-extract-plugin
module.exports = {"form-group":"styles_form-group__28p9Z","title":"styles_title__3Ty7P","body":"styles_body__1tgra","form-group__link":"styles_form-group__link__3BbE_"};